import {
    Button,
    CircularProgress,
    Grid,
    IconButton,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    withStyles
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import DialogComp from '../../../../Core/Controls/Dialog/DialogComp';
import moment from 'moment';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { getTcardBranchData, getTcardData, getTCardWipData, postTCardsDragStatus } from '../../../../Core/Service/TCardDashboard-service';

import TCardDashboardModal from '../Dashboard/T-cardModal';
import TCardsCloseDay from '../Dashboard/TCardsCloseDay';

import { useHistory } from 'react-router-dom';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { getTCards_ScreenDropdown } from '../../../../Core/Service/checkInRole';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import AppContext from '../../../../App/AppContext';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Tcard } from '../Dashboard/TcardTemplates/mainTcard';
import '../Dashboard/TcardTemplates/tcardTemplate.scss';
import { stubTrue } from 'lodash';

const marginBottom = { marginBottom: 8 };

const useStyles = makeStyles({
    table: {
        minWidth: '1280px',
        width: '100%',
        tableLayout: 'fixed'
    },
    colHeight: {
        overflowY: 'auto',
        verticalAlign: 'baseline'
    },
    draggingOver: {
        backgroundColor: 'rgba(59, 130, 246, 0.08) !important'
    },
    noRecordFound: {
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '10px',
        fontWeight: 500,
        color: '#94a3b8',
        background: '#fafafa',
        border: '1px dashed #e2e8f0',
        borderRadius: '4px',
        margin: '3px 2px'
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#1e293b',
        color: theme.palette.common.white,
        padding: '6px 12px',
        borderBottom: '1px solid #334155'
    },
    body: {
        fontSize: 13,
        padding: '0px 3px 8px 3px',
        border: 'none',
        verticalAlign: 'baseline'
    }
}))(TableCell);

const HeadingTableCell = withStyles((theme) => ({
    head: {
        padding: '0px 3px',
        border: 'none'
    },
    body: {
        padding: '0px 3px 6px 3px',
        border: 'none',
        verticalAlign: 'baseline'
    }
}))(TableCell);

// const Tcard = ({ customer, registration, color, isLoanVehicle, status, date, tCardsID, handleTcardOpen, textColor, legendItems }) => {
//     const portalSetting = AppStorage.getPortalSetting();
//     const classes = useStyles();
//     const [hovered, setHovered] = useState(false);

//     return (
//         <div
//             style={{ background: color }}
//             className={classes.Tcard}
//             onMouseEnter={() => setHovered(true)}
//             onMouseLeave={() => setHovered(false)}
//             onClick={() => handleTcardOpen(true, tCardsID, false, color)}
//         >
//             <Grid container justifyContent="space-between">
//                 <Grid item style={{ display: 'flex' }}>
//                     <Typography style={{ fontSize: 11, fontWeight: 600, textAlign: 'left', color: textColor }}>{registration} </Typography> &nbsp;
//                     {isLoanVehicle && (
//                         <div
//                             style={{
//                                 fontSize: 6,
//                                 fontWeight: 600,
//                                 background: portalSetting.portalSettingsLoanVehicleBgColor,
//                                 color: portalSetting.portalSettingsLoanVehicleTextColor,
//                                 padding: '2px 4px',
//                                 height: 10
//                             }}
//                         >
//                             {portalSetting.portalSettingsLoanVehicleText}
//                         </div>
//                     )}
//                 </Grid>

//                 <Grid item>
//                     <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'right', color: textColor }}>{customer}</Typography>
//                 </Grid>
//             </Grid>
//             <Grid container justifyContent="space-between" alignItems="center">
//                 <Grid item xs={2}>
//                     <Typography style={{ fontSize: 10, fontWeight: 600, textAlign: 'left', color: textColor }}>
//                         {date ? moment(date).format('DD/MM') : 'N/A'}
//                     </Typography>
//                 </Grid>
//                 <Grid item xs={10}>
//                     {/* {status && ( */}
//                     <div style={{ display: 'grid', rowGap: 1, gridTemplateColumns: 'repeat(9, 1fr)', justifyContent: 'flex-end' }}>
//                         {legendItems?.map((k) => {
//                             if (status[k.st]) {
//                                 return (
//                                     <div key={k.st} style={{ margin: '0px 2px' }}>
//                                         <Typography
//                                             style={{
//                                                 fontSize: 8,
//                                                 fontWeight: 600,
//                                                 background: k.background,
//                                                 color: k.color ? k.color : 'white',
//                                                 padding: 2
//                                             }}
//                                         >
//                                             {k.label}
//                                         </Typography>
//                                     </div>
//                                 );
//                             } else {
//                                 return (
//                                     <div key={k.st} style={{ margin: '0px 2px' }}>
//                                         <Typography
//                                             style={{
//                                                 fontSize: 6,
//                                                 fontWeight: 600,
//                                                 // background: k.background,
//                                                 color: 'white',
//                                                 padding: 2
//                                             }}
//                                         ></Typography>
//                                     </div>
//                                 );
//                             }
//                         })}
//                     </div>
//                     {/* )} */}
//                 </Grid>
//                 {status.motloc && (
//                     <Grid item xs={12}>
//                         <Typography style={{ fontSize: 9, fontWeight: 600, textAlign: 'left', color: textColor }}>
//                             {status.motloc} ({moment(status.motdate).format('DD-MM-YYYY HH:MM')})
//                         </Typography>
//                     </Grid>
//                 )}
//             </Grid>
//         </div>
//     );
// };

const InProgress = () => {
    const curretDate = moment();
    const portalSetting = AppStorage.getPortalSetting();
    const classes = useStyles();
    const statusObject = AppStorage.getTCardStatus();
    const history = useHistory();

    const [workTypeArray] = useState(() => {
        try {
            const wt = AppStorage.getTCardWorkType();
            return wt ? JSON.parse(wt) : [];
        } catch {
            return [];
        }
    });

    const setMotColor = (type, isColor) => {
        try {
            if (workTypeArray && workTypeArray.length > 0) {
                const obj = workTypeArray.find((j) => j.workType === type);

                if (obj) {
                    return isColor ? (obj.tc ?? 'black') : (obj.bgc ?? '');
                }
            }
            return isColor ? 'black' : '';
        } catch (error) {
            console.error('setMotColor error:', error);
            return isColor ? 'black' : '';
        }
    };

    const legendItems = [
        {
            label: portalSetting.portalSettingsCollectionDeliverText,
            background: portalSetting.portalSettingsCollectionDeliverBgColor || 'black',
            color: portalSetting.portalSettingsCollectionDeliverTextColor || 'white',
            st: 'cd'
        },
        {
            label: portalSetting.portalSettingsCustomerWaitingText,
            background: portalSetting.portalSettingsCustomerWaitingBgColor || 'black',
            color: portalSetting.portalSettingsCustomerWaitingTextColor || 'white',
            st: 'waiting'
        },
        {
            label: portalSetting.portalSettingsServiceText,
            background: portalSetting.portalSettingsServiceBgColor || 'black',
            color: portalSetting.portalSettingsServiceTextColor || 'white',
            st: 'service'
        },
        {
            label: portalSetting.portalSettingsInspectionText,
            background: portalSetting.portalSettingsInspectionBgColor || 'black',
            color: portalSetting.portalSettingsInspectionTextColor || 'white',
            st: 'inspection'
        },
        {
            label: portalSetting.portalSettingsMOTText,
            background: portalSetting.portalSettingsMOTBgColor || 'black',
            color: portalSetting.portalSettingsMOTTextColor || 'white',
            st: 'mot'
        },
        {
            label: portalSetting.portalSettingsRepairText,
            background: portalSetting.portalSettingsRepairBgColor || 'black',
            color: portalSetting.portalSettingsRepairTextColor || 'white',
            st: 'repair'
        },
        {
            label: portalSetting.portalSettingsNightShiftText,
            background: portalSetting.portalSettingsNightShiftBgColor || 'black',
            color: portalSetting.portalSettingsNightShiftTextColor || 'white',
            st: 'ns'
        },
        {
            label: portalSetting.portalSettingsRecallJobText,
            background: portalSetting.portalSettingsRecallJobBgColor || 'black',
            color: portalSetting.portalSettingsRecallJobTextColor || 'white',
            st: 'recall'
        },

        {
            label: portalSetting.portalSettingsTachoText,
            background: portalSetting.portalSettingsTachoBgColor || 'black',
            color: portalSetting.portalSettingsTachoTextColor || 'white',
            st: 'tacho'
        }
    ];

    const { hideModal, showToast } = useContext(AppContext);

    const [tCardList, setTCardList] = useState({
        bookingConfirmed: [],
        startDate: moment(),
        waitingStart: [],
        noShow: [],
        motPrep: [],
        inProg: [],
        awaitingCallBack: [],
        partOrder: [],
        recall: [],
        branchID: '',
        toSchedule: [],
        tCardID: null,
        tCardSelectedColor: '',
        tCardStatus: [],
        allocatedHours: [],
        usersHoliday: [],
        tpNames: [],
        showLoader: true
    });

    const [Start, setStart] = useState('');
    const [openModal, setOpenModal] = useState(false);
    // const [closeDayModal, setCloseDayModal] = useState(false);
    const [End, setEnd] = useState('');
    const [branchList, setBranchList] = useState([]);
    // const [selectedDate, setSelectedDate] = useState(null);
    const [status, setStatus] = useState([]);
    const [loader, setLoader] = useState(true);

    const [expand, setExpand] = useState({});

    const [filters, setFilters] = useState({
        regNo: '',
        cust: ''
    });

    const [filterTcard, setFilterTcard] = useState({});
    const [fullScreen, setFullScreen] = useState(false);

    const handleFullScreen = () => setFullScreen((prev) => !prev);

    const reset = () => {
        setFilters({ regNo: '', cust: '' });
        if (filterTcard.tCardStatus) {
            setTCardList((st) => ({
                ...st,
                tCardStatus: filterTcard.tCardStatus,
                recall: filterTcard.recall || []
            }));
        }
    };

    const COLUMNS_PER_ROW = 6;

    const row1Statuses = (status || [])
        .filter((m) => {
            const seq = m.sequence || m.tCardStatusequence;
            if (!seq || seq === '0-0') return false;
            const [row] = seq.split('-').map(Number);
            return row === 1;
        })
        .sort((a, b) => {
            const seqA = a.sequence || a.tCardStatusequence;
            const seqB = b.sequence || b.tCardStatusequence;
            const colA = Number(seqA.split('-')[1]) || 0;
            const colB = Number(seqB.split('-')[1]) || 0;
            return colA - colB;
        });

    const row2Statuses = (status || [])
        .filter((m) => {
            const seq = m.sequence || m.tCardStatusequence;
            if (!seq || seq === '0-0') return false;
            const [row] = seq.split('-').map(Number);
            return row === 2;
        })
        .sort((a, b) => {
            const seqA = a.sequence || a.tCardStatusequence;
            const seqB = b.sequence || b.tCardStatusequence;
            const colA = Number(seqA.split('-')[1]) || 0;
            const colB = Number(seqB.split('-')[1]) || 0;
            return colA - colB;
        });

    // Fixed 6 columns per row (pad with null to ensure alignment)
    const row1Columns = Array.from({ length: COLUMNS_PER_ROW }, (_, i) => row1Statuses[i] || null);
    const row2Columns = Array.from({ length: COLUMNS_PER_ROW }, (_, i) => row2Statuses[i] || null);

    const handleTcardOpen = (cond, id, res, color) => {
        setOpenModal(cond);
        setTCardList((state) => ({
            ...state,
            tCardID: id,
            tCardSelectedColor: color
        }));

        res && fetchData();
    };

    const fetchData = useCallback(async () => {
        if (tCardList.branchID) {
            setLoader(true);
            let res = await getTCardWipData(tCardList.branchID);
            if (res.success) {
                let data = res.data.tCards;
                let tpNames = new Set(data.map((k) => k.tp));
                setFilterTcard((st) => ({
                    ...st,
                    tCardStatus: data || [],
                    recall: data.filter((k) => k.status === 'RECALL'),
                    tpNames: Array.from(tpNames)
                }));

                setTCardList((st) => ({
                    ...st,
                    tCardStatus: data || [],
                    recall: data.filter((k) => k.status === 'RECALL'),
                    tpNames: Array.from(tpNames)
                }));

                setLoader(false);
            }
        }
    }, [tCardList.branchID, Start, End]);

    useEffect(() => {
        let fetchData = async () => {
            let res = await getTCards_ScreenDropdown('', true);
            if (res.success) {
                setStatus(res.data.tCardsStatus.filter((s) => s.id !== 1 && s.id !== 10) || []);
            } else {
                console.error(res);
            }
        };
        return fetchData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleExpand = (name, value) => {
        setExpand((st) => ({ ...st, [name]: value }));
    };

    const handleFilter = (value, key) => {
        let searchValue = value.toLowerCase();

        let { tCardStatus = [], recall = [] } = filterTcard;

        const filterByKey = (data) => data.filter((item) => item[key]?.toLowerCase().includes(searchValue));

        setTCardList((prev) => ({
            ...prev,
            tCardStatus: filterByKey(tCardStatus),
            recall: filterByKey(recall)
        }));
    };

    const handleChange = (e) => {
        const branchID = e.target.value;
        const tempObj = branchList.find((k) => k.id == branchID);

        if (tempObj) {
            const branchName = tempObj.name;

            const tempData = {
                ...JSON.parse(localStorage.getItem('_dashboard_') || '{}'),
                BranchBytime: branchName,
                selectedValueByTech: branchName,
                BranchPartReq: branchName,
                branchShortName: branchName
            };
            localStorage.setItem('_dashboard_', JSON.stringify(tempData));

            const btTimeData = {
                ...JSON.parse(localStorage.getItem('FiltterParams') || '{}'),
                branchShortName: branchName
            };
            localStorage.setItem('FiltterParams', JSON.stringify(btTimeData));
        }

        // Always run state updates
        // setLoader(true);
        setTCardList((prev) => ({
            ...prev,
            branchID
        }));
    };

    const handleDragEnd = async (result) => {
        try {
            const { source, destination, draggableId } = result;

            if (!destination) return;

            if (source.droppableId === destination.droppableId && source.index === destination.index) {
                console.log('Item dropped in the same position. No action taken.');
                return;
            }

            const newState = {
                ...tCardList,
                recall: [...tCardList.recall],
                tCardStatus: [...tCardList.tCardStatus]
            };

            let draggedItem = null;
            let sourceArray = '';

            if (source.droppableId === 'recall') {
                draggedItem = newState.recall.find((item) => item.tCardsID.toString() === draggableId);
                sourceArray = 'recall';
            } else if (source.droppableId === 'ToBeSchWithoutDate') {
                draggedItem = newState.tCardStatus.find((item) => item.tCardsID.toString() === draggableId && item.status === 'TO BE SCHEDULED');
                sourceArray = 'tCardStatus';
            } else {
                draggedItem = newState.tCardStatus.find((item) => item.tCardsID.toString() === draggableId && item.status === source.droppableId);
                sourceArray = 'tCardStatus';
            }

            if (!draggedItem) {
                console.error(`Dragged item with ID ${draggableId} not found in source: ${source.droppableId}`);
                return;
            }

            // Remove from source
            if (sourceArray === 'recall') {
                newState.recall = newState.recall.filter((item) => item.tCardsID.toString() !== draggableId);
            } else {
                newState.tCardStatus = newState.tCardStatus.filter((item) => !(item.tCardsID.toString() === draggableId && item.status === source.droppableId));
            }

            // Update item status
            if (destination.droppableId !== 'recall') {
                draggedItem = {
                    ...draggedItem,
                    status: destination.droppableId
                };
            }

            // Add to destination
            if (destination.droppableId === 'recall') {
                newState.recall.push(draggedItem);
            } else {
                newState.tCardStatus.push(draggedItem);
            }

            // Update UI optimistically
            setTCardList(newState);

            // Map destination to status
            const statusArray = JSON.parse(statusObject);
            const targetStatus = destination.droppableId === 'recall' ? 'BOOKING CONFIRMED' : destination.droppableId;
            const StatusID = statusArray.find((k) => k.status === targetStatus);

            if (!StatusID) {
                console.error(`Status not found for ${targetStatus}`);
                return;
            }

            const payload = {
                tCardsStatusID: StatusID.id,
                tCardsID: +draggableId
            };

            const res = await postTCardsDragStatus(payload);

            if (res.success) {
                setLoader(true);
                fetchData();
                showToast(`T-card moved from ${source.droppableId} to ${destination.droppableId} successfully`);
            } else {
                showToast(`Failed to move T-card from ${source.droppableId} to ${destination.droppableId}`);
            }
        } catch (error) {
            console.error('Error during handleDragEnd:', error);
            showToast('Unexpected error occurred while processing drag-and-drop');
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getTcardBranchData();
                if (res?.success && Array.isArray(res.data?.branches)) {
                    const branches = res.data.branches;
                    setBranchList(branches);

                    const dashboardData = JSON.parse(localStorage.getItem('_dashboard_') || '{}');
                    const selectedBranchName = dashboardData.BranchPartReq;

                    const matchedBranch = branches.find((b) => b.name === selectedBranchName);
                    const fallbackBranchID = branches[0]?.id || null;

                    setTCardList((prev) => ({
                        ...prev,
                        branchID: matchedBranch?.id || fallbackBranchID
                    }));
                } else {
                    console.error('Failed to fetch branches or no branches returned');
                }
            } catch (error) {
                console.error('Error fetching TCard branch data:', error);
            }
        };

        fetchData();
    }, []);

    const handleCustomerFilter = (e) => {
        let { value } = e.target;

        setFilters((st) => ({ ...st, cust: value }));
        handleFilter(value, 'cust');
    };

    const handleRegNoFilter = (e) => {
        let { value } = e.target;

        handleFilter(value, 'reg');
        setFilters((st) => ({ ...st, regNo: value }));
    };

    function getWeekNumber(dateStr) {
        if (!dateStr) return 'No Date';

        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return 'Invalid Date';

        const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        const dayNum = tempDate.getUTCDay() || 7;
        tempDate.setUTCDate(tempDate.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
        const weekNo = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);
        return `Week ${weekNo} `;
    }

    const toBeScheduledCards = (data) => {
        // console.log(data, 'toBeScheduledCards');
        const list = data.filter((item) => item.status === 'TO BE SCHEDULED' && item.dd);

        const groupedByWeek = list.reduce((acc, card) => {
            const week = getWeekNumber(card.dd);
            if (!acc[week]) acc[week] = [];
            acc[week].push(card);
            return acc;
        }, {});
        // return groupedByWeek;
        return Object.entries(groupedByWeek || {});
    };

    const renderStatusCell = (statusObj, rowIndex, colIndex) => {
        if (!statusObj) {
            return (
                <StyledTableCell
                    align="center"
                    key={`empty-${rowIndex}-${colIndex}`}
                    style={{
                        width: '16.666%',
                        minWidth: '16.666%',
                        maxWidth: '16.666%',
                        padding: '0px 3px 8px 3px',
                        verticalAlign: 'top'
                    }}
                >
                    {/* Empty cell placeholder to maintain exact 6-column alignment */}
                </StyledTableCell>
            );
        }

        const statusName = statusObj.name;
        if (!statusName) return null;

        if (statusName === 'RECALL') {
            return (
                <StyledTableCell
                    align="center"
                    key={statusObj.id || `${rowIndex}-${colIndex}`}
                    style={{
                        width: '16.666%',
                        minWidth: '16.666%',
                        maxWidth: '16.666%',
                        padding: '0px 3px 8px 3px',
                        verticalAlign: 'top'
                    }}
                >
                    <div className="tcard-status-header">
                        <Typography className="tcard-status-title">
                            <span>Recall</span>
                            <span className="tcard-status-count">{tCardList.recall.length}</span>
                        </Typography>
                    </div>
                    <div className={`${classes.colHeight} custom-scroll`} style={{ ...marginBottom, minHeight: '60px' }}>
                        {tCardList.tpNames.map((tpName) => (
                            <div key={tpName}>
                                <Typography
                                    style={{
                                        padding: '2px 6px',
                                        textAlign: 'center',
                                        fontWeight: 700,
                                        textTransform: 'uppercase',
                                        fontSize: 9.5,
                                        letterSpacing: '0.3px',
                                        backgroundColor: '#e0f2fe',
                                        color: '#0369a1',
                                        borderTop: '1px solid #bae6fd',
                                        borderBottom: '1px solid #bae6fd',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative'
                                    }}
                                >
                                    <span>{tpName}</span>
                                    {tpName == 'Next Inspection' && (
                                        <span style={{ position: 'absolute', right: 4, display: 'flex', alignItems: 'center' }}>
                                            {!expand[tpName] ? (
                                                <ExpandMoreIcon
                                                    onClick={() => handleExpand(tpName, true)}
                                                    style={{
                                                        fontSize: 14,
                                                        cursor: 'pointer'
                                                    }}
                                                />
                                            ) : (
                                                <ExpandLessIcon
                                                    onClick={() => handleExpand(tpName, false)}
                                                    style={{
                                                        fontSize: 14,
                                                        cursor: 'pointer'
                                                    }}
                                                />
                                            )}
                                        </span>
                                    )}
                                </Typography>

                                <Droppable droppableId={'RECALL'} direction="vertical">
                                    {(provided, snapshot) => {
                                        const items = tCardList.recall.filter((m) => m.tp === tpName);

                                        return (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className={snapshot.isDraggingOver ? 'droppable-active' : ''}
                                            >
                                                {items.length === 0 && !snapshot.isDraggingOver && (
                                                    <div className="card-body-container-main-wrapper-no-record">
                                                        <span>No Record Found</span>
                                                    </div>
                                                )}

                                                {items.map((k, index) => (
                                                    <Draggable key={k.tCardsID} draggableId={k.tCardsID.toString()} index={index}>
                                                        {(provided, dragSnapshot) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                                style={{
                                                                    marginBottom: '4px',
                                                                    ...provided.draggableProps.style
                                                                }}
                                                            >
                                                                <Tcard
                                                                    legendItems={legendItems}
                                                                    handleTcardOpen={handleTcardOpen}
                                                                    date={k.bd}
                                                                    days={k.days}
                                                                    customer={k.cust}
                                                                    isLoanVehicle={k.loanVehicle}
                                                                    registration={k.reg}
                                                                    color={k.bgc || k.bg}
                                                                    textColor={k.tc}
                                                                    tCardsID={k.tCardsID}
                                                                    wn={k.wn}
                                                                    vsc={k.vsc}
                                                                    breakdown={k.breakdown}
                                                                    breakdownStatus={k.breakdownStatus}
                                                                    breakdownTime={k.breakdownTime}
                                                                    pt={k.pt}
                                                                    workDetails={k.workDetails}
                                                                    technicians={k.technicians}
                                                                    status={{
                                                                        recall: k.recall,
                                                                        tacho: k.tacho,
                                                                        motdate: k.motdate,
                                                                        motloc: k.motloc,
                                                                        mot: k.mot,
                                                                        repair: k.repair,
                                                                        inspection: k.inspection,
                                                                        cd: k.cd,
                                                                        waiting: k.waiting,
                                                                        service: k.service,
                                                                        ns: k.ns
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}

                                                {snapshot.isDraggingOver && items.length > 0 && (
                                                    <div className="card-body-container-main-wrapper-no-record is-drag-target">
                                                        <span>Drop Here</span>
                                                    </div>
                                                )}
                                                {provided.placeholder}
                                            </div>
                                        );
                                    }}
                                </Droppable>
                            </div>
                        ))}
                    </div>
                </StyledTableCell>
            );
        }

        if (statusName === 'TO BE SCHEDULED') {
            const dataList = toBeScheduledCards(tCardList?.tCardStatus);
            return (
                <StyledTableCell
                    align="center"
                    key={statusObj.id || `${rowIndex}-${colIndex}`}
                    style={{
                        width: '16.666%',
                        minWidth: '16.666%',
                        maxWidth: '16.666%',
                        padding: '0px 3px 8px 3px',
                        verticalAlign: 'top'
                    }}
                >
                    <div className="tcard-status-header">
                        <Typography className="tcard-status-title">
                            <span>{statusName}</span>
                            <span className="tcard-status-count">{tCardList?.tCardStatus?.filter((m) => m.status === statusName).length || 0}</span>
                        </Typography>
                    </div>
                    <Droppable droppableId="TO BE SCHEDULED" direction="vertical" obj={statusObj}>
                        {(provided, snapshot) => (
                            <div style={{ minHeight: '60px' }}>
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className={`${classes.colHeight} custom-scroll ${snapshot.isDraggingOver ? 'droppable-active' : ''}`}
                                >
                                    {dataList.length === 0 ? (
                                        <div className={`card-body-container-main-wrapper-no-record ${snapshot.isDraggingOver ? 'is-drag-target' : ''}`}>
                                            <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                        </div>
                                    ) : (
                                        dataList
                                            .sort(([weekA], [weekB]) => {
                                                const numA = parseInt(weekA.replace(/\D/g, ''), 10);
                                                const numB = parseInt(weekB.replace(/\D/g, ''), 10);
                                                return numA - numB;
                                            })
                                            .map(([week, cards]) => (
                                                <div
                                                    key={week}
                                                    style={{
                                                        background: portalSetting.portalSettingsIsHolidayColor
                                                    }}
                                                >
                                                    <Typography
                                                        style={{
                                                            fontWeight: 700,
                                                            fontSize: 9.5,
                                                            letterSpacing: '0.3px',
                                                            textTransform: 'uppercase',
                                                            background: portalSetting.portalSettingsIsHolidayBgColor || '#f1f5f9',
                                                            color: portalSetting.portalSettingsIsHolidayColor || '#334155',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            padding: '2px 6px',
                                                            borderTop: '1px solid #e2e8f0',
                                                            borderBottom: '1px solid #e2e8f0'
                                                        }}
                                                    >
                                                        <span>
                                                            {week} - {cards.length}
                                                        </span>
                                                        <span>
                                                            {!expand[week] ? (
                                                                <ExpandMoreIcon
                                                                    onClick={() => handleExpand(week, true)}
                                                                    style={{
                                                                        fontSize: 14,
                                                                        marginRight: 2,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <ExpandLessIcon
                                                                    onClick={() => handleExpand(week, false)}
                                                                    style={{
                                                                        fontSize: 14,
                                                                        marginRight: 2,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                            )}
                                                        </span>
                                                    </Typography>

                                                    {expand[week] &&
                                                        cards.map((k, index) => (
                                                            <Draggable key={k.tCardsID} draggableId={k.tCardsID.toString()} index={index} obj={k}>
                                                                {(provided, dragSnapshot) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                                        style={{
                                                                            marginBottom: '4px',
                                                                            ...provided.draggableProps.style
                                                                        }}
                                                                    >
                                                                        <Tcard
                                                                            legendItems={legendItems}
                                                                            handleTcardOpen={handleTcardOpen}
                                                                            date={k.bd || k.dd}
                                                                            days={k.days}
                                                                            customer={k.cust}
                                                                            isLoanVehicle={k.loanVehicle}
                                                                            registration={k.reg}
                                                                            color={k.bgc || k.bg}
                                                                            textColor={k.tc}
                                                                            tCardsID={k.tCardsID}
                                                                            wn={k.wn}
                                                                            vsc={k.vsc}
                                                                            breakdown={k.breakdown}
                                                                            breakdownStatus={k.breakdownStatus}
                                                                            breakdownTime={k.breakdownTime}
                                                                            pt={k.pt}
                                                                            workDetails={k.workDetails}
                                                                            technicians={k.technicians}
                                                                            status={{
                                                                                recall: k.recall,
                                                                                tacho: k.tacho,
                                                                                motdate: k.motdate,
                                                                                motloc: k.motloc,
                                                                                mot: k.mot,
                                                                                repair: k.repair,
                                                                                inspection: k.inspection,
                                                                                cd: k.cd,
                                                                                waiting: k.waiting,
                                                                                service: k.service,
                                                                                ns: k.ns
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                </div>
                                            ))
                                    )}
                                    {provided.placeholder}
                                </div>
                                <div>
                                    {tCardList?.tCardStatus
                                        ?.filter((m) => m.status === 'TO BE SCHEDULED' && !m.dd)
                                        .map((k, index) => (
                                            <React.Fragment key={k.tCardsID || index}>
                                                {index === 0 && (
                                                    <Typography
                                                        style={{
                                                            fontWeight: 700,
                                                            fontSize: 9.5,
                                                            letterSpacing: '0.3px',
                                                            textTransform: 'uppercase',
                                                            background: portalSetting.portalSettingsIsHolidayBgColor || '#f1f5f9',
                                                            color: portalSetting.portalSettingsIsHolidayColor || '#334155',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            padding: '2px 6px',
                                                            borderTop: '1px solid #e2e8f0',
                                                            borderBottom: '1px solid #e2e8f0'
                                                        }}
                                                    >
                                                        <span>Date not set</span>
                                                        <span>
                                                            {!expand['notSet'] ? (
                                                                <ExpandMoreIcon
                                                                    onClick={() => handleExpand('notSet', true)}
                                                                    style={{
                                                                        fontSize: 14,
                                                                        marginRight: 2,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <ExpandLessIcon
                                                                    onClick={() => handleExpand('notSet', false)}
                                                                    style={{
                                                                        fontSize: 14,
                                                                        marginRight: 2,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                            )}
                                                        </span>
                                                    </Typography>
                                                )}
                                                {expand['notSet'] && (
                                                    <Draggable key={k.tCardsID} draggableId={k.tCardsID.toString()} index={index} obj={k}>
                                                        {(provided, dragSnapshot) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                                style={{
                                                                    marginBottom: '4px',
                                                                    ...provided.draggableProps.style
                                                                }}
                                                            >
                                                                <Tcard
                                                                    legendItems={legendItems}
                                                                    handleTcardOpen={handleTcardOpen}
                                                                    date={k.bd || k.dd}
                                                                    days={k.days}
                                                                    customer={k.cust}
                                                                    isLoanVehicle={k.loanVehicle}
                                                                    registration={k.reg}
                                                                    color={k.bgc || k.bg}
                                                                    textColor={k.tc}
                                                                    tCardsID={k.tCardsID}
                                                                    wn={k.wn}
                                                                    vsc={k.vsc}
                                                                    breakdown={k.breakdown}
                                                                    breakdownStatus={k.breakdownStatus}
                                                                    breakdownTime={k.breakdownTime}
                                                                    pt={k.pt}
                                                                    workDetails={k.workDetails}
                                                                    technicians={k.technicians}
                                                                    status={{
                                                                        recall: k.recall,
                                                                        tacho: k.tacho,
                                                                        motdate: k.motdate,
                                                                        motloc: k.motloc,
                                                                        mot: k.mot,
                                                                        repair: k.repair,
                                                                        inspection: k.inspection,
                                                                        cd: k.cd,
                                                                        waiting: k.waiting,
                                                                        service: k.service,
                                                                        ns: k.ns
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    {provided.placeholder}
                                </div>
                            </div>
                        )}
                    </Droppable>
                </StyledTableCell>
            );
        }

        return (
            <StyledTableCell
                align="center"
                key={statusObj.id || `${rowIndex}-${colIndex}`}
                style={{
                    width: '16.666%',
                    minWidth: '16.666%',
                    maxWidth: '16.666%',
                    padding: '0px 3px 8px 3px',
                    verticalAlign: 'top'
                }}
            >
                <div className="tcard-status-header">
                    <Typography className="tcard-status-title" title={statusName}>
                        <span>{statusName}</span>
                        <span className="tcard-status-count">{tCardList?.tCardStatus?.filter((m) => m.status === statusName).length || 0}</span>
                    </Typography>
                </div>
                <Droppable droppableId={statusName} direction="vertical">
                    {(provided, snapshot) => {
                        const cardsForStatus = tCardList.tCardStatus.filter((m) => m.status === statusName);

                        return (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className={`${classes.colHeight} custom-scroll ${snapshot.isDraggingOver ? 'droppable-active' : ''}`}
                                style={{
                                    minHeight: '60px',
                                    maxHeight: 'calc((100vh - 200px) / 2)',
                                    overflowY: 'auto',
                                    position: 'relative'
                                }}
                            >
                                {cardsForStatus.length === 0 ? (
                                    <div className={`card-body-container-main-wrapper-no-record ${snapshot.isDraggingOver ? 'is-drag-target' : ''}`}>
                                        <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                    </div>
                                ) : (
                                    cardsForStatus.map((k, index) => (
                                        <Draggable key={k.tCardsID} draggableId={k.tCardsID.toString()} obj={k} index={index}>
                                            {(provided, dragSnapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                    style={{
                                                        marginBottom: '4px',
                                                        ...provided.draggableProps.style
                                                    }}
                                                >
                                                    <Tcard
                                                        legendItems={legendItems}
                                                        days={k.days}
                                                        handleTcardOpen={handleTcardOpen}
                                                        date={k.bd}
                                                        customer={k.cust}
                                                        isLoanVehicle={k.loanVehicle}
                                                        registration={k.reg}
                                                        color={k.bgc || k.bg}
                                                        textColor={k.tc}
                                                        tCardsID={k.tCardsID}
                                                        wn={k.wn}
                                                        vsc={k.vsc}
                                                        breakdown={k.breakdown}
                                                        breakdownStatus={k.breakdownStatus}
                                                        breakdownTime={k.breakdownTime}
                                                        pt={k.pt}
                                                        workDetails={k.workDetails}
                                                        technicians={k.technicians}
                                                        status={{
                                                            recall: k.recall,
                                                            tacho: k.tacho,
                                                            motdate: k.motdate,
                                                            motloc: k.motloc,
                                                            mot: k.mot,
                                                            repair: k.repair,
                                                            inspection: k.inspection,
                                                            cd: k.cd,
                                                            waiting: k.waiting,
                                                            service: k.service,
                                                            ns: k.ns
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </Draggable>
                                    ))
                                )}
                                {snapshot.isDraggingOver && cardsForStatus.length > 0 && (
                                    <div className="card-body-container-main-wrapper-no-record is-drag-target">
                                        <span>{'Drop Here'}</span>
                                    </div>
                                )}
                                {provided.placeholder}
                            </div>
                        );
                    }}
                </Droppable>
            </StyledTableCell>
        );
    };

    return (
        <div
            className="custom-scroll"
            style={{
                position: !fullScreen ? 'static' : 'fixed',
                top: 0,
                left: 0,
                width: !fullScreen ? '100%' : '100vw',
                height: !fullScreen ? '100%' : '100vh',
                background: '#f8fafc',
                zIndex: 1000,
                overflowY: 'hidden'
            }}
        >
            <TableContainer component={Paper} style={{ height: fullScreen ? '100vh' : 'calc(100vh - 75px)', boxShadow: 'none', borderRadius: 0 }}>
                {loader ? (
                    <div style={{ marginTop: 30, width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Table className={classes.table} aria-label="simple table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="left" colSpan={6} style={{ padding: '6px 12px', border: 'none' }}>
                                    <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                                        <Grid item>
                                            <Grid container spacing={1} alignItems="center">
                                                {legendItems.map((item, index) => (
                                                    <Grid item key={index}>
                                                        <div
                                                            className="tcard-legend-badge"
                                                            style={{
                                                                background: item.background,
                                                                color: item.color
                                                            }}
                                                        >
                                                            {item.label}
                                                        </div>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                                                <Grid item>
                                                    <input
                                                        className="tcard-search-input"
                                                        onChange={handleCustomerFilter}
                                                        placeholder="🔍 Search customer..."
                                                        value={filters.cust}
                                                        name="cust"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <input
                                                        className="tcard-search-input"
                                                        onChange={handleRegNoFilter}
                                                        placeholder="🔍 Search Reg No..."
                                                        value={filters.regNo}
                                                        name="regNo"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title={!fullScreen ? 'Full Screen' : 'Normal View'}>
                                                        <span className="tcard-icon-btn" onClick={handleFullScreen}>
                                                            {!fullScreen ? (
                                                                <FullscreenIcon style={{ fontSize: 20 }} />
                                                            ) : (
                                                                <FullscreenExitIcon style={{ fontSize: 20 }} />
                                                            )}
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item>
                                                    <div
                                                        className="tcard-action-btn-primary"
                                                        onClick={() => history.push('/CheckInDashboard?branchID=' + tCardList.branchID)}
                                                    >
                                                        + Create T-Card
                                                    </div>
                                                </Grid>
                                                {/* <Grid item>
                                                    <div
                                                        className="tcard-action-btn-success"
                                                        onClick={() => history.push('/Tcards')}
                                                    >
                                                        Current Week
                                                    </div>
                                                </Grid> */}
                                                <Grid item>
                                                    <Tooltip title="Reset Filters">
                                                        <span className="tcard-icon-btn" onClick={reset}>
                                                            <RotateLeftIcon style={{ fontSize: 20 }} />
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item>
                                                    <select className="tcard-branch-select" onChange={handleChange} value={tCardList.branchID}>
                                                        {branchList.map((btn, i) => {
                                                            return (
                                                                <option key={i} value={btn.id}>
                                                                    {btn.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <TableBody>
                                {/* Row 1 (Fixed 6 columns) */}
                                <TableRow>{row1Columns.map((statusObj, i) => renderStatusCell(statusObj, 1, i))}</TableRow>

                                {/* Row 2 (Fixed 6 columns) */}
                                <TableRow>{row2Columns.map((statusObj, i) => renderStatusCell(statusObj, 2, i))}</TableRow>
                            </TableBody>
                        </DragDropContext>
                    </Table>
                )}
            </TableContainer>

            {openModal ? <TCardDashboardModal id={tCardList.tCardID} onClose={handleTcardOpen} tCardSelectedColor={tCardList?.tCardSelectedColor} /> : null}
        </div>
    );
};

export default InProgress;
